import { render } from "./pb-imagelink.vue?vue&type=template&id=ea9000c4"
import script from "./pb-imagelink.vue?vue&type=script&lang=js"
export * from "./pb-imagelink.vue?vue&type=script&lang=js"

import "./pb-imagelink.vue?vue&type=style&index=0&id=ea9000c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__